import { CouponType } from '@schemas'

export class Coupon implements CouponType {
	constructor({
		id = '',
		name = '',
		email = '',
		code = '',
		discountUsd = 0,
		discountKrw = 0,
		quantity = 0,
		expiredAt = '',
		useYn = 0,
		unitUsd = 0,
		unitKrw = 0,
		updatedBy = '',
		updatedAt = '',
		createdAt = '',
		createdBy = '',
		expiredYn = 0,
		outOfQtyYn = 0,
		usageQuantity = 0,
		totalPayoutDueUsd = 0,
		totalPayoutDueKrw = 0,
		status = '',
	}: CouponType) {
		this.id = id === null ? '' : id
		this.name = name === null ? '' : name
		this.email = email === null ? '' : email
		this.code = code === null ? '' : code
		this.discountUsd = discountUsd === null ? 0 : Number(discountUsd)
		this.discountKrw = discountKrw === null ? 0 : Number(discountKrw)
		this.quantity = quantity === null ? 0 : Number(quantity)
		this.expiredAt = expiredAt === null ? '' : expiredAt
		this.useYn = useYn === null ? 0 : useYn
		this.unitUsd = unitUsd === null ? 0 : unitUsd
		this.unitKrw = unitKrw === null ? 0 : unitKrw
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.createdAt = createdAt === null ? '' : createdAt
		this.createdBy = createdBy === null ? '' : createdBy
		this.expiredYn = expiredYn === null ? 0 : expiredYn
		this.outOfQtyYn = outOfQtyYn === null ? 0 : outOfQtyYn
		this.usageQuantity = usageQuantity === null ? 0 : usageQuantity
		this.totalPayoutDueUsd = totalPayoutDueUsd === null ? 0 : totalPayoutDueUsd
		this.totalPayoutDueKrw = totalPayoutDueKrw === null ? 0 : totalPayoutDueKrw
		this.status = status === null ? '' : status
	}

	id: string
	name: string
	email: string
	code: string
	discountUsd: number
	discountKrw: number
	quantity: number
	expiredAt: string
	useYn: number
	unitUsd: number
	unitKrw: number
	updatedBy: string
	updatedAt: string
	createdBy: string
	createdAt: string
	expiredYn: number
	outOfQtyYn: number
	usageQuantity: number
	totalPayoutDueUsd: number
	totalPayoutDueKrw: number
	status: string
}
